import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BellIcons } from '../../icons/icons';
import { NAVBAR_MENU_KEYS, NS } from '../../i18n/constants/keys';

const NOTIFICATION_KEYS = [
  NAVBAR_MENU_KEYS.notifications.welcome,
  NAVBAR_MENU_KEYS.notifications.assessmentReady,
  NAVBAR_MENU_KEYS.notifications.newApplication,
] as const;

export const MobileNotifications = () => {
  const { t } = useTranslation(NS.navbarMenus);
  const [notifications] = useState<string[]>([]);

  return (
    <div className='rounded-xl border border-slate-200 bg-white p-3 shadow-sm'>
      <div className='mb-2 flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          <div className='flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-50'>
            <BellIcons className='h-4 w-4 text-emerald-600' />
          </div>
          <h3 className='text-xs font-extrabold uppercase tracking-wide text-slate-500'>
            {t(NAVBAR_MENU_KEYS.notifications.title)}
          </h3>
        </div>
        { notifications.length > 0 && (
          <span className='rounded-full bg-red-500 px-2 py-0.5 text-[11px] font-bold text-white'>
            { notifications.length }
          </span>
        ) }
      </div>

      { notifications.length === 0 ? (
        <div className='rounded-lg bg-slate-50 px-3 py-2 text-xs font-semibold text-slate-500'>
          {t(NAVBAR_MENU_KEYS.notifications.emptyMobile)}
        </div>
      ) : (
        <div className='space-y-2'>
          { notifications.map((notification, index) => (
            <div
                key={index}
                className='rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700'
            >
              { notification }
            </div>
          )) }
        </div>
      ) }
    </div>
  );
};
